module.exports = __webpack_public_path__ + "img/442.3c6a58cd.jpg";